import React from 'react';
import Proptypes from 'prop-types';
import { useIntl } from 'react-intl';
import getTimeElapsedString from '../../../../_shared/utils/getTimeElapsedString';
import MixpanelConfig from '../../../../_shared/constants/mixpanelConfig';
import utmSource from '../../../../_shared/constants/utmSource';

import {
  DateCreated,
  Details,
  Title,
  BoldedText,
  ItemContainer,
  StatusLabel
} from '../Styles';
import { StyledAlert, StyledThumbnail, AlertContent } from './Styles';

const propTypes = {
  alerts: Proptypes.arrayOf(Proptypes.objectOf(Proptypes.any)),
  isAlertsError: Proptypes.bool.isRequired,
  getManufacturer: Proptypes.func.isRequired,
  locale: Proptypes.string.isRequired,
  handleRedirect: Proptypes.func.isRequired
};

const defaultProps = {
  alerts: []
};

const Alerts = ({
  alerts,
  isAlertsError,
  getManufacturer,
  locale,
  handleRedirect
}) => {
  const intl = useIntl();

  return (
    <>
      {!isAlertsError &&
        alerts?.map(
          ({
            id,
            tradeId,
            dealerId,
            tradeState,
            dateCreated,
            subtitle,
            tradeVehicleSummary
          }) => {
            const {
              thumbnailUrl,
              vehicleSummary: { model, modelYear, trim }
            } = tradeVehicleSummary;
            const timeElapsed = getTimeElapsedString(dateCreated, locale);

            const onClick = () => {
              const eventName = MixpanelConfig.names.selectAlert;
              handleRedirect({
                eventName,
                tradeId,
                dealerId,
                tradeState,
                type: subtitle,
                referrer: utmSource.alertsList
              });
            };

            return (
              <ItemContainer data-testid="alert-item" key={`alert-${id}`}>
                <StyledAlert onClick={onClick}>
                  <StyledThumbnail src={thumbnailUrl} />
                  <AlertContent>
                    <Title>
                      <BoldedText>{modelYear} </BoldedText>
                      {getManufacturer(model.manufacturerId)}
                      <BoldedText> {model.displayName}</BoldedText>
                    </Title>
                    <Details isAlert>{trim}</Details>
                    <DateCreated isAlert>
                      <BoldedText>{subtitle}</BoldedText> {timeElapsed}
                    </DateCreated>
                  </AlertContent>
                </StyledAlert>
              </ItemContainer>
            );
          }
        )}
      {!isAlertsError && alerts.length === 0 && (
        <StatusLabel data-testid="no-alerts">
          {intl.formatMessage({ id: 'notifications.alerts.none' })}
        </StatusLabel>
      )}
      {isAlertsError && (
        <StatusLabel data-testid="alerts-error">
          {intl.formatMessage({ id: 'notifications.alerts.error' })}
        </StatusLabel>
      )}
    </>
  );
};

Alerts.propTypes = propTypes;
Alerts.defaultProps = defaultProps;

export default Alerts;
